/**
 * Dual-mode auth token helpers.
 * When AUTH_COOKIE_MODE=true (build-time via webpack DefinePlugin), refresh tokens
 * live in an httpOnly cookie — SPA only keeps the access token in localStorage.
 * When false, both tokens stay in localStorage (legacy bearer mode).
 */

export const AUTH_COOKIE_MODE =
  typeof process !== 'undefined' && process.env && process.env.AUTH_COOKIE_MODE === 'true';

export function persistAuthTokens({ accessToken, refreshToken }) {
  if (accessToken) localStorage.setItem('accessToken', accessToken);
  if (AUTH_COOKIE_MODE) {
    localStorage.removeItem('refreshToken');
  } else if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  }
}

export function clearAuthTokens() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
}

export function getAccessToken() {
  return localStorage.getItem('accessToken');
}

export function getRefreshTokenBody() {
  if (AUTH_COOKIE_MODE) return {};
  const refreshToken = localStorage.getItem('refreshToken');
  return refreshToken ? { refreshToken } : {};
}

/** True when localStorage suggests a prior login we can restore. */
export function hasStoredSession() {
  if (getAccessToken()) return true;
  // Cookie mode: refresh lives in httpOnly cookie (unreadable). Without an
  // access token we cannot distinguish a guest from a cookie-only session.
  if (AUTH_COOKIE_MODE) return false;
  return !!localStorage.getItem('refreshToken');
}
